import angular from 'angular';
import '../services/organization-group';
import '../services/errors';
import '../services/globals';
import './modals/organization-groups';
import '../components/status';

const module = angular.module('whyline.controllers.organization-groups', [
  'whyline.components.status',
  'whyline.modals.organization-group',
  'whyline.services.organization-group',
  'whyline.services.errors',
  'whyline.services.globals',
]);

const OrganizationGroupsController = ($scope, $uibModal, $translate, OrganizationGroupService, GlobalsService, dialog, currentOrganization) => {
  /*@ngInject*/

  // View init
  $scope.organizationGroups = OrganizationGroupService.GetAll();
  $scope.quantityOfItems = 8;

  // Toggle group enabled
  $scope.switch = organizationGroup => {
    const enabled = !organizationGroup.enabled;
    const confirmMessage = enabled ? 'organization_group_enable_all_places' : 'organization_group_disable_all_places';
    dialog
      .confirm($translate.instant(confirmMessage))
      .then(() => {
        OrganizationGroupService.Switch(organizationGroup, enabled);
      }).catch(() => {
        organizationGroup.enabled = !enabled;
      });
  };

  // Modal
  $scope.open = organizationGroupId => {
    $uibModal.open({
      templateUrl: '/templates/components/modals/organization-groups-modal.html',
      size: 'lg',
      controller: 'OrganizationGroupModalController',
      resolve: {
        organizationGroupId: () => organizationGroupId,
        currentOrganization
      }
    });
  };
};

module.exports = module.controller('OrganizationGroupsController', OrganizationGroupsController);
